import EachComponent from '../../../Components/Entity/EachComponent.component';
import React from 'react';
import PropTypes from 'prop-types';
import Alerts from './Alerts.component';
import EmployeesDataProvider from '../../../Utils/Companies/Managers-Employees/EmployeesDataProvider';
import ManagersDataProvider from '../../../Utils/Companies/Managers-Employees/ManagersDataProvider';
// import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const EmployeesTab = ({ company = [], companyId = '' }) => {
  // const [filtered, setFiltered] = useState([]); // State for filtered results
  // const [searchTerm, setSearchTerm] = useState(''); // State for search input
  // const [err, setErr] = useState('');
  const { alerts } = company || [];

  return (
    <section>
      <h3>Employees & Managers</h3>
      {/* {err && <p className="error">{err}</p>} */}
      <Alerts alerts={alerts} />

      {/* Search Input */}
      {/* <div className="search-container">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div> */}

      {/* Managers and Employees */}
      <ManagersDataProvider companyId={companyId}>
        {(managers) => (
          <EmployeesDataProvider companyId={companyId}>
            {(employees) => {
              // Combine managers and employees
              // const combined = [...(managers || []), ...(employees || [])];

              // // Filter results based on search term
              // const filteredResults = combined.filter((person) =>
              //   `${person.firstName} ${person.lastName}`
              //     .toLowerCase()
              //     .includes(searchTerm.toLowerCase())
              // );

              // // Set error if no results are found
              // useEffect(() => {
              //   if (filteredResults.length === 0 && searchTerm) {
              //     setErr('No employees or managers found');
              //   } else {
              //     setErr('');
              //   }
              //   setFiltered(filteredResults);
              // }, [searchTerm, managers, employees]);

              return (
                <>
                  {/* Managers */}
                  <p className="greyBorder m1T">Managers</p>
                  {(managers || [])?.map((c) => (
                    <EachComponent
                      key={c?._id}
                      name={c?.firstName + ' ' + c?.lastName}
                      active={c?.active}
                      route={`/user/profile/${c?._id}`}
                    />
                  ))}

                  {/* Employees */}
                  <p className="greyBorder m1T">Employees</p>
                  {(employees || [])?.map((c) => (
                    <EachComponent
                      key={c?._id}
                      active={c?.active}
                      name={c?.firstName + ' ' + c?.lastName}
                      route={`/user/profile/${c?._id}`}
                    />
                  ))}
                </>
              );
            }}
          </EmployeesDataProvider>
        )}
      </ManagersDataProvider>
    </section>
  );
};

EmployeesTab.propTypes = {
  company: PropTypes.array,
  companyId: PropTypes.string,
};

export default EmployeesTab;
